(() => {
  const rootPath = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const endpoint = (path) => `${String(rootPath()).replace(/\/?$/, '/')}${String(path).replace(/^\//, '')}`;
  const normalizeVariantId = (value) => {
    const match = String(value || '').match(/(\d+)$/);
    if (!match) throw new Error('No se pudo identificar el pack seleccionado.');
    return match[1];
  };
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);
  const money = (cents, currency = 'MXN') => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'es-MX', { style: 'currency', currency }).format(cents / 100);
    } catch (_) {
      return `${(cents / 100).toFixed(2)} ${currency}`;
    }
  };

  const drawerElement = () => document.querySelector('[data-vv-cart-drawer]');

  const closeDrawer = () => {
    const drawer = drawerElement();
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    document.body.classList.remove('vv-cart-open');
  };

  const openDrawer = () => {
    const drawer = drawerElement();
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    document.body.classList.add('vv-cart-open');
    const panel = drawer.querySelector('.vv-cart__panel');
    if (panel) panel.focus();
  };

  const renderCart = (cart) => {
    const drawer = drawerElement();
    if (!drawer) return;
    const items = drawer.querySelector('[data-vv-cart-items]');
    const empty = drawer.querySelector('[data-vv-cart-empty]');
    const footer = drawer.querySelector('[data-vv-cart-footer]');
    const total = drawer.querySelector('[data-vv-cart-total]');
    if (!items || !empty || !footer || !total) return;

    const hasItems = cart.items && cart.items.length > 0;
    empty.hidden = hasItems;
    footer.hidden = !hasItems;
    total.textContent = money(cart.total_price, cart.currency || 'MXN');

    items.innerHTML = hasItems ? cart.items.map((item) => {
      const image = (item.featured_image && item.featured_image.url) || item.image || '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      const giftTitle = item.properties && item.properties['Regalo digital'];
      const prioritySupport = item.properties && item.properties['Soporte de configuración'];
      const properties = Object.entries(item.properties || {})
        .filter(([key, value]) => key && !key.startsWith('_') && value && key !== 'Regalo digital' && key !== 'Soporte de configuración')
        .map(([key, value]) => `<small>${escapeHtml(key)}: ${escapeHtml(value)}</small>`)
        .join('');
      const ebookImage = drawer.dataset.vvEbookImage || '';
      const gift = giftTitle ? `<div class="vv-cart__gift">
        ${ebookImage ? `<img src="${escapeHtml(ebookImage)}" width="72" height="96" alt="Portada de la guía digital Vigtu">` : ''}
        <span><em>REGALO INCLUIDO</em><b>E-book de seguridad para el hogar</b></span>
        <strong>GRATIS</strong>
      </div>` : '';
      const support = prioritySupport ? `<div class="vv-cart__support"><span aria-hidden="true">✓</span>${escapeHtml(prioritySupport)}</div>` : '';
      return `<article class="vv-cart__item">
        <div class="vv-cart__product">
          ${image ? `<img src="${escapeHtml(image)}" width="148" height="148" alt="${escapeHtml(item.product_title)}">` : '<span></span>'}
          <div class="vv-cart__item-main">
            <b>${escapeHtml(item.product_title)}</b>
            ${variant ? `<small>${escapeHtml(variant)}</small>` : ''}
            ${properties}
          </div>
          <div class="vv-cart__item-price">
            <strong>${money(item.final_line_price, cart.currency || 'MXN')}</strong>
            <button class="vv-cart__remove" type="button" data-vv-cart-change data-key="${escapeHtml(item.key)}" data-quantity="0">Eliminar</button>
          </div>
        </div>
        ${gift}
        ${support}
        <div class="vv-cart__qty" aria-label="Cantidad">
          <button type="button" data-vv-cart-change data-key="${escapeHtml(item.key)}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Reducir cantidad">−</button>
          <span>${item.quantity}</span>
          <button type="button" data-vv-cart-change data-key="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Aumentar cantidad">+</button>
        </div>
      </article>`;
    }).join('') : '';
  };

  const getCart = async () => {
    const response = await fetch(endpoint('cart.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('No se pudo cargar el carrito.');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };

  const changeCart = async (key, quantity) => {
    const response = await fetch(endpoint('cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!response.ok) throw new Error('No se pudo actualizar la cantidad.');
    const cart = await response.json();
    renderCart(cart);
  };

  const setupDrawer = () => {
    const drawer = drawerElement();
    if (!drawer || drawer.dataset.vvReady) return;
    drawer.dataset.vvReady = '1';
    drawer.querySelectorAll('[data-vv-cart-close]').forEach((button) => button.addEventListener('click', closeDrawer));
    drawer.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-vv-cart-change]');
      if (!button) return;
      button.disabled = true;
      try {
        await changeCart(button.dataset.key, Number(button.dataset.quantity));
      } catch (error) {
        const message = drawer.querySelector('[data-vv-cart-message]');
        if (message) message.textContent = error.message;
      } finally {
        button.disabled = false;
      }
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
    });
  };

  const bindProductForm = (root, form) => {
    if (form.dataset.vvFormReady) return;
    form.dataset.vvFormReady = '1';
    const id = form.querySelector('input[type="hidden"][name="id"]');
    const price = root.querySelector('[data-vv-price]');
    const priceMain = root.querySelector('[data-vv-price-main]');
    const compare = root.querySelector('[data-vv-compare]');
    const save = root.querySelector('[data-vv-save]');
    const main = root.querySelector('[data-vv-main]');
    const guideProperty = form.querySelector('[data-vv-guide-property]');
    const priorityProperty = form.querySelector('[data-vv-priority-property]');
    const guideBonus = form.querySelector('[data-vv-guide-bonus]');
    const storageOffer = form.querySelector('[data-vv-storage-offer]');
    const storageVariant = form.querySelector('[data-vv-storage-variant]');
    const storageQuantity = form.querySelector('[data-vv-storage-quantity]');
    const storagePrice = form.querySelector('[data-vv-storage-price]');
    const storageStatus = form.querySelector('[data-vv-storage-status]');
    const error = root.querySelector('[data-vv-form-error]');
    const sticky = document.querySelector('[data-vv-sticky-price]');
    const stickyLabel = document.querySelector('[data-vv-sticky-label]');

    const updateExtras = (radio) => {
      const packIndex = Number(radio.dataset.packIndex || 1);
      if (guideProperty) guideProperty.disabled = radio.dataset.hasGuide !== 'true';
      if (guideBonus) guideBonus.hidden = radio.dataset.hasGuide !== 'true';
      if (priorityProperty) priorityProperty.disabled = radio.dataset.hasPriority !== 'true';
      if (!storageOffer || !storageQuantity) return;
      const maxCards = packIndex === 1 ? 1 : (packIndex === 2 ? 2 : 4);
      storageQuantity.value = '0';
      Array.from(storageQuantity.options).forEach((option) => {
        const qty = Number(option.value);
        option.hidden = qty > maxCards;
        option.disabled = qty > maxCards;
      });
      if (storageStatus) {
        storageStatus.textContent = `Opcional · recomendado: ${maxCards} ${maxCards === 1 ? 'tarjeta' : 'tarjetas'} para grabar en todas las cámaras`;
      }
    };

    const updateStorageVariant = () => {
      if (!storageOffer || !storageVariant) return;
      const option = storageVariant.options[storageVariant.selectedIndex];
      storageOffer.dataset.variantId = storageVariant.value;
      if (storagePrice) storagePrice.textContent = option ? (option.dataset.price || '') : '';
    };
    if (storageVariant) {
      storageVariant.addEventListener('change', updateStorageVariant);
      updateStorageVariant();
    }

    form.querySelectorAll('[data-vv-variant]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (id) id.value = radio.value;
        if (price) price.textContent = radio.dataset.price;
        if (priceMain) priceMain.textContent = radio.dataset.price;
        if (compare) compare.textContent = radio.dataset.compare || '';
        if (save) save.textContent = radio.dataset.save || '';
        if (sticky) sticky.textContent = radio.dataset.price;
        if (stickyLabel) {
          const labels = ['1 cámara · protección esencial', '2 cámaras · más popular', '4 cámaras · mejor oferta'];
          stickyLabel.textContent = labels[Math.max(0, Number(radio.dataset.packIndex || 1) - 1)];
        }
        updateExtras(radio);
        if (main && radio.dataset.image) {
          main.src = radio.dataset.image;
          main.srcset = '';
          main.alt = radio.dataset.alt || '';
        }
        root.querySelectorAll('[data-vv-thumb]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
      });
    });

    const selectedRadio = form.querySelector('[data-vv-variant]:checked');
    if (selectedRadio) {
      if (id) id.value = normalizeVariantId(selectedRadio.value);
      updateExtras(selectedRadio);
    }

    form.addEventListener('submit', async (event) => {
      if (!window.fetch) return;
      event.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      if (submit) {
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
      }
      if (error) {
        error.hidden = true;
        error.textContent = '';
      }

      try {
        const selected = form.querySelector('[data-vv-variant]:checked');
        if (!selected) throw new Error('Selecciona un pack antes de continuar.');
        const selectedVariantId = normalizeVariantId(selected.value || (id && id.value));
        if (id) id.value = selectedVariantId;
        const properties = {};
        form.querySelectorAll('input[name^="properties["]:not(:disabled)').forEach((input) => {
          const match = input.name.match(/^properties\[(.+)\]$/);
          if (match && input.value) properties[match[1]] = input.value;
        });
        const items = [{ id: selectedVariantId, quantity: 1, properties }];
        const storageQty = storageQuantity ? Number(storageQuantity.value || 0) : 0;
        if (storageOffer && storageQty > 0 && storageOffer.dataset.variantId) {
          const packCount = selected && selected.dataset.packIndex === '3' ? 4 : Number(selected ? selected.dataset.packIndex : 1);
          items.push({
            id: normalizeVariantId(storageOffer.dataset.variantId),
            quantity: storageQty,
            properties: {
              'Asociado a': `Pack de ${packCount} ${packCount === 1 ? 'cámara' : 'cámaras'}`,
              'Grabación local': `${storageQty} ${storageQty === 1 ? 'cámara equipada' : 'cámaras equipadas'}`,
              'Capacidad microSD': storageVariant && storageVariant.options[storageVariant.selectedIndex] ? storageVariant.options[storageVariant.selectedIndex].dataset.title : ''
            }
          });
        }
        const response = await fetch(endpoint('cart/add.js'), {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items })
        });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) {
          if (response.status >= 500 || response.status === 404) {
            HTMLFormElement.prototype.submit.call(form);
            return;
          }
          if (error) {
            error.textContent = payload.description || payload.message || 'No se ha podido añadir este pack.';
            error.hidden = false;
          }
          return;
        }
        await getCart();
        openDrawer();
      } catch (caughtError) {
        if (caughtError && (caughtError.name === 'TypeError' || /fetch|network|red/i.test(caughtError.message || ''))) {
          HTMLFormElement.prototype.submit.call(form);
          return;
        }
        if (error) {
          error.textContent = caughtError && caughtError.message ? caughtError.message : 'No se ha podido añadir este pack. Inténtalo de nuevo.';
          error.hidden = false;
        }
      } finally {
        if (submit) {
          submit.disabled = false;
          submit.removeAttribute('aria-busy');
        }
      }
    });
  };

  const setupAutoplayVideos = (root) => {
    root.querySelectorAll('[data-vv-autoplay-video]').forEach((video) => {
      if (video.dataset.vvVideoReady) return;
      video.dataset.vvVideoReady = '1';
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');

      const markLoaded = () => {
        const media = video.closest('.vv-hero-video__media');
        if (media) media.classList.add('is-loaded');
      };
      const play = () => {
        if (document.hidden) return;
        const promise = video.play();
        if (promise && typeof promise.catch === 'function') promise.catch(() => {});
      };
      const pause = () => {
        if (!video.paused) video.pause();
      };

      video.addEventListener('loadeddata', markLoaded, { once: true });
      video.addEventListener('ended', play);
      if (video.readyState >= 2) markLoaded();

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            video.dataset.vvInView = entry.isIntersecting ? '1' : '0';
            if (entry.isIntersecting) play();
            else pause();
          });
        }, { rootMargin: '160px 0px', threshold: 0.15 });
        observer.observe(video);
      } else {
        video.dataset.vvInView = '1';
        window.requestAnimationFrame(play);
      }
    });
  };

  const setupInfographicsCarousel = (root) => {
    root.querySelectorAll('[data-vv-infographics-carousel]').forEach((carousel) => {
      if (carousel.dataset.vvCarouselReady) return;
      carousel.dataset.vvCarouselReady = '1';
      const track = carousel.querySelector('[data-vv-infographics-track]');
      const previous = carousel.querySelector('[data-vv-infographics-prev]');
      const next = carousel.querySelector('[data-vv-infographics-next]');
      if (!track || !previous || !next) return;

      const move = (direction) => {
        const card = track.querySelector('.vv-infographic');
        const styles = window.getComputedStyle(track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap) || 10;
        const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.88;
        track.scrollBy({ left: direction * distance, behavior: 'smooth' });
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
    });
  };

  const init = (root) => {
    if (!root || root.dataset.vvReady) return;
    root.dataset.vvReady = '1';

    const mainImage = root.querySelector('[data-vv-main]');
    const thumbs = Array.from(root.querySelectorAll('[data-vv-thumb]'));
    const thumbsTrack = root.querySelector('[data-vv-thumbs]');

    const selectThumb = (index, scrollThumb = true) => {
      if (!mainImage || !thumbs.length) return;
      const safeIndex = Math.max(0, Math.min(index, thumbs.length - 1));
      const button = thumbs[safeIndex];
      mainImage.src = button.dataset.src;
      mainImage.srcset = '';
      mainImage.alt = button.dataset.alt || '';
      thumbs.forEach((item) => item.setAttribute('aria-pressed', 'false'));
      button.setAttribute('aria-pressed', 'true');
      if (scrollThumb && typeof button.scrollIntoView === 'function') {
        button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    };

    thumbs.forEach((button, index) => {
      button.addEventListener('click', () => selectThumb(index));
    });

    const mainFrame = mainImage && mainImage.closest('.vv-hero__main');
    if (mainFrame && thumbs.length > 1) {
      let touchStartX = 0;
      let touchStartY = 0;
      mainFrame.addEventListener('touchstart', (event) => {
        if (event.touches.length !== 1) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
      }, { passive: true });
      mainFrame.addEventListener('touchend', (event) => {
        const touch = event.changedTouches && event.changedTouches[0];
        if (!touch) return;
        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;
        if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
        const currentIndex = Math.max(0, thumbs.findIndex((item) => item.getAttribute('aria-pressed') === 'true'));
        selectThumb(currentIndex + (deltaX < 0 ? 1 : -1));
      }, { passive: true });
    }

    if (thumbsTrack) {
      const moveThumbs = (direction) => {
        const firstThumb = thumbsTrack.querySelector('[data-vv-thumb]');
        const step = firstThumb ? firstThumb.getBoundingClientRect().width + 8 : thumbsTrack.clientWidth * 0.75;
        thumbsTrack.scrollBy({ left: direction * step * 2, behavior: 'smooth' });
      };
      const prevThumbs = root.querySelector('[data-vv-thumbs-prev]');
      const nextThumbs = root.querySelector('[data-vv-thumbs-next]');
      if (prevThumbs) prevThumbs.addEventListener('click', () => moveThumbs(-1));
      if (nextThumbs) nextThumbs.addEventListener('click', () => moveThumbs(1));
    }

    root.querySelectorAll('form[action*="/cart/add"]').forEach((form) => bindProductForm(root, form));
    setupAutoplayVideos(root);
    setupInfographicsCarousel(root);

    root.querySelectorAll('[data-vv-slider]').forEach((slider) => {
      const range = slider.querySelector('input[type="range"]');
      if (!range) return;
      const update = () => slider.style.setProperty('--pos', `${range.value}%`);
      update();
      range.addEventListener('input', update);
      range.addEventListener('change', update);
    });
  };

  const boot = () => {
    setupDrawer();
    document.querySelectorAll('[data-vv-root]').forEach(init);
    document.querySelectorAll('[data-vv-sticky-add]').forEach((button) => {
      if (button.dataset.vvStickyReady) return;
      button.dataset.vvStickyReady = '1';
      button.addEventListener('click', () => {
        const form = document.querySelector('#vigtu-view-buy form[action*="/cart/add"]');
        if (form && typeof form.requestSubmit === 'function') form.requestSubmit();
        else document.querySelector('#vigtu-view-buy')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  };

  if (window.__vigtuViewBootV5) {
    window.__vigtuViewBootV5();
    return;
  }

  window.__vigtuViewBootV5 = boot;
  boot();
  document.addEventListener('visibilitychange', () => {
    document.querySelectorAll('[data-vv-autoplay-video]').forEach((video) => {
      if (document.hidden) {
        video.pause();
      } else if (video.dataset.vvInView === '1') {
        const replay = video.play();
        if (replay && typeof replay.catch === 'function') replay.catch(() => {});
      }
    });
  });
  document.addEventListener('shopify:section:load', (event) => {
    setupDrawer();
    const root = event.target.querySelector('[data-vv-root]') || event.target;
    if (root.matches && root.matches('[data-vv-root]')) init(root);
  });
})();
